import { DataManager, ODataV4Adaptor, Query } from '@syncfusion/ej2-data';
import {
  GridComponent,
  QueryCellInfoEventArgs,
} from '@syncfusion/ej2-react-grids';
import { EditSettingsModel } from '@syncfusion/ej2-react-grids';
import * as React from 'react';
import Message from '../../utils/Message/Message';
import { AiOutlinePaperClip } from 'react-icons/ai';
import { BsSearch } from 'react-icons/bs';
import {
  ChipDirective,
  ChipListComponent,
  ChipsDirective,
} from '@syncfusion/ej2-react-buttons';
import { ThemeContext } from '../../context/theme.context';
import {
  MultiSelectComponent as MultiSelectC,
  Inject as DDInject,
} from '@syncfusion/ej2-react-dropdowns';
import GlobalSearch from '../../components/GlobalSearch';
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import GlobalGrid from '../../components/GlobalGrid';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import {
  EditWorkOrder,
  GetMaxProntoRowIdData,
} from '../../services/CloudScheduler/CloudSchedulerServices';
import { camelCase } from 'lodash';
import OrderAttachments from './OrderAttachments';
import { EditMassOrder, SendRequest } from '../../utils/CreateRequest';
import { addToQuery, applyTheRule } from '../../utils/BussinesRuleBuilder';
import { GetTablenameFromTask } from '../../utils/GetTablenameFromTask';
import GlobalDialog from '../../components/GlobalDialog';
import OperationTemplate from '../Settings/OperationTemplate/OperationTemplate';
import { preparingTemplatePoint } from '../../utils/OperationPreparingForTemplate';
import { useEffect, useState } from 'react';
import { getPriority } from '../../utils/GetPriorityColor';
import './style.css';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeResetDataLoadingBoolenValue,
  setIsPlanSelected,
  setSearchCaseGantt,
  setSearchCaseOp,
  setSearchCaseOrder,
} from '../../redux/search.slice';
import { GlobalMultiSelection } from '../../components/GlobalDropDown';
import { getParamsDD } from '../../utils/GridParams';
import MassiveOrderEdit from '../../utils/MassOrderEdit';
import {
  EditOperations,
  getOperations,
} from '../../services/Operations/OperationServices';
import { all_information, loadingShow } from '../../App';
import { io } from 'socket.io-client';
import {
  EditMexListOperations,
  FetchNewMexRecordsOperations,
  SyncFromMex,
  SyncFullOperations,
} from '../../services/MexServices/Orders/OrderService';
import { AxiosResponse } from 'axios';
import {
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import Loader from 'react-spinners/PulseLoader';
import AssignWorkOrderDialog from './AssignWorkOrderDialog';
import { toast } from 'react-toastify';
import { GetChangedOrders } from '../../services/WorkOrders/WorkOrderService';
interface IProps {
  outter_asset_code?: string | undefined;
  noNeedFilterPanel?: boolean;
  gridRef?: (component: GridComponent) => void;
  multiSelection?: boolean;
}

export let g_worder: string = '';
var mounted: boolean = false;
let selectedChips: Array<any> = [];
let selectedChipValues: Array<any> = [];
let departmentchips: Array<any> = [];
let theQueryScheduleNumber = '';
let theQueryStatuses = '';
let theQueryPrioritys = '';
let theQueryDepartment = '';
let theQuerySection = '';
let theQueryProntoReference = '';
let theQueryHoldReason = '';
let theQueryAsset = '';
let theQueryOutterAsset = '';
let theQueryType = '';
let theQueryResp = '';
let theQueryDate = '';
let theQuerySearch = '';
let theQueryPlanId = '';
let theQueryWorkOrderCode = '';
let theQueryReference = '';
let chips: ChipListComponent = new ChipListComponent({});
let editOptions: EditSettingsModel = {
  allowEditing: true,
  allowAdding: false,
  allowDeleting: true,
  showDeleteConfirmDialog: true,
  mode: 'Batch',
  allowNextRowEdit: true,
};
let the_current_query = '';
let searchText: string = '';
let gridCPWorkorder: GridComponent;
let refreshTokens = [' ', '  ', '   ', '    '];
let isAgentAlive = false;
const WorkOrders = ({
  outter_asset_code,
  noNeedFilterPanel,
  gridRef,
  multiSelection,
}: IProps) => {
  const dispatch = useDispatch();
  let timezone_offset =
    -1 * useSelector((state: any) => state.search.timezone_offset);
  const [refreshRequest, setrefreshRequest] = useState<string>('false');
  const [resetDataToastinId, setresetDataToastinId]: any = useState(null);
  const [isDataResettingComponentHandle, setisDataResettingComponentHandle] =
    useState<boolean>(false);
  const reduxSearchS = useSelector((state: any) => state.search);
  searchText = reduxSearchS.searchCaseOrder;
  const [commitToErpClicked, setcommitToErpClicked] = useState<boolean>(false);
  const [resetData, setResetData] = useState<boolean>(false);
  const [isResetDataLoading, setisResetDataLoading] = useState<boolean>(false);
  const [clickTimes, setClickTimes] = useState<number>(0);
  const ERP_TYPE = process.env.REACT_APP_ERP_TYPE;
  const erpTypeName = 'MEX';
  const [questionDialog, setQuestionDialog] = useState(false);
  const [hideDialogEventPlan, setHideDialogEventPlan] = useState(false);
  const [hideAddDialog, setHideAddDialog] = useState(false);
  const [massiveEditDialog, setMassiveEditDialog] = useState(false);
  const [showTemplateDialog, setShowTemplateDialog] = useState(false);
  const [PriorityColorData, setPriorityColorData] = useState<Array<any>>([]);
  const [schdeduleStartDateVal, setSchdeduleStartDateVal] = useState<Date[]>();
  const [current_query, setCurrentQuery] = useState('');
  const [loadSignal, setLoadSignal] = useState(false);
  const [currentWOC, setCurrentWOC] = useState<string | undefined>(undefined);
  const [order_detail, setOrderDetail] = useState({
    order_code: undefined,
    order_id: undefined,
  });
  const [gridGetQuery, setGridGetQuery] = useState<string>('order');
  const serverOffsetMillis = 60 * 1000 * -600;
  const localOffset = new Date().getTimezoneOffset();
  const localOffsetMillis = 60 * 1000 * localOffset;

  var moment = require('moment-timezone');
  const refreshGridFunction = () => {
    gridCPWorkorder?.refresh();
    setLoadSignal(true);
    setrefreshRequest('true');
  };
  function extractStringValue(jsonString: string): string {
    const obj = JSON.parse(jsonString);
    const valuesString = JSON.stringify(obj);
    const regex = /"([^"]*)"/g;
    let match;
    const results: string[] = [];

    while ((match = regex.exec(valuesString)) !== null) {
      if (match[1] !== 'value') {
        results.push(match[1]);
      }
    }
    return results.length > 0 ? results[0] : '';
  }
  function extractNumbers(text: string): string {
    const regex = /\d+/g;
    const numbers = text.match(regex);
    return numbers ? numbers.join(',') : '';
  }

  function extractCharacters(str: any): string[] {
    if (str != null) {
      var parsed = JSON.parse(str);
      var characters = parsed.value.map(function (char: any) {
        return char.toString();
      });
      return characters;
    }
    return [];
  }
  const context = React.useContext(ThemeContext);
  const socket = io(process.env.REACT_APP_API_GLOBAL_URL as string, {
    autoConnect: false,
    transports: ['websocket'],
  });

  const [theDatas, setTheDatas] = useState<any[]>([]);
  let answer: boolean;
  let buttonsOrder: ButtonPropsModel[] = [
    {
      buttonModel: { content: 'All Data' },
      click: () => {
        answer = true;
        loadingShow(true, 'Waiting for fetch operations...');

        FetchNewMexRecordsOperations(timezone_offset)
          .then((result: any) => {
            if (result.status == 200) {
              loadingShow(false);
              if (result.data.length === 0) {
                Message.success('There is no new record...');
                refreshGridFunction();
              } else {
                Message.success(`Fetched records successfully...`);
                refreshGridFunction();
              }
            }
          })
          .catch((err) => {
            loadingShow(false);
            Message.error('Fetching failed!!!');
          });
        setQuestionDialog(false);
      },
    },
    {
      buttonModel: { content: 'Planned Data' },
      click: () => {
        answer = false;
        let thePlanID = Number(localStorage.getItem('cs_plan_dd_value'));
        if (thePlanID === 0) {
          Message.error('Please select a plan...');
        } else {
          loadingShow(true, 'Waiting for fetch operations...');
          FetchNewMexRecordsOperations(timezone_offset, thePlanID)
            .then((result: any) => {
              if (result.status == 200) {
                loadingShow(false);
                if (result.data.length === 0) {
                  Message.success('There is no new record...');
                  refreshGridFunction();
                } else {
                  Message.success(`Fetched records successfully...`);
                  refreshGridFunction();
                }
              }
            })
            .catch((err) => {
              loadingShow(false);
              Message.error('Fetching failed!!!');
            });
          setQuestionDialog(false);
        }
      },
    },
  ];
  // let resetDataButton: ButtonPropsModel[] = [
  //   {
  //     buttonModel: { content: 'Yes' },
  //     click: () => {
  //       setResetData(false);
  //       resetDataFunction();
  //     },
  //   },
  //   {
  //     buttonModel: { content: 'No' },
  //     click: () => {
  //       setResetData(false);
  //     },
  //   },
  // ];
  let commitToErpButtonModel: ButtonPropsModel[] = [
    {
      buttonModel: { content: 'Yes' },
      click: async () => {
        Message.info('Committing to erp');
        if (gridCPWorkorder?.getSelectedRecords().length > 0) {
          let theTableName = await GetTablenameFromTask('work order');
          if (theTableName === '') {
            theTableName = 'job5mfc';
          } else {
            theTableName = theTableName.trim();
            let theValue = theTableName.split(' ');
            theTableName = theValue[theValue.length - 1];
          }
          var theQuery = '';
          let theDatas: any = gridCPWorkorder?.getSelectedRecords();
          theDatas.map((item: any) => {
            item.scheduled_start_date = item?.scheduled_start_date?.toString();
          });
          loadingShow(true, 'Loading...');

          EditMexListOperations(theDatas, timezone_offset)
            .then((result: AxiosResponse) => {
              if (result.status == 200) {
                loadingShow(false);
                Message.success('Committed successfully...');
              }
            })
            .catch((err) => {
              loadingShow(false);
              Message.error('Commit failed!!!');
            });
        }

        if (gridCPWorkorder?.getSelectedRecords().length > 0) {
          let theDatas = gridCPWorkorder?.getSelectedRecords();
          theDatas = theDatas.map((theData: any) => {
            return { ...theData, isEffected: false };
          });
          if (ERP_TYPE === 'MEX') {
            const differenceOffsetMillis =
              serverOffsetMillis - localOffsetMillis;

            theDatas.map((item: any) => {
              item.scheduled_start_date = new Date(
                new Date(item.scheduled_start_date)?.getTime() +
                differenceOffsetMillis
              ).toString();
              item.scheduled_end_date = new Date(
                new Date(item.scheduled_end_date)?.getTime() +
                differenceOffsetMillis
              ).toString();
            });
          }

          EditWorkOrder(theDatas, -timezone_offset)
            .then((res) => {
              buildQuery(' ');
            })
            .catch((er) => {
              Message.error('Error occured');
            });
        }
        setcommitToErpClicked(false);
      },
    },
    {
      buttonModel: { content: 'No' },
      click: () => {
        setcommitToErpClicked(false);
      },
    },
  ];
  const priorityColorChip = () => {
    return (
      <div className='row md-6'>
        <ChipListComponent
          id='chip-filter-cp'
          selectedChips={selectedChipValues}
          selection='Multiple'
          ref={(el: ChipListComponent) => (chips = el)}
          click={isChipClicked2.bind(this)}
        >
          <ChipsDirective>
            {PriorityColorData.map((el: any, index: number) => {
              return (
                <ChipDirective
                  text={`P${el.priority_code.trim()}`}
                  cssClass={`e-chip-text${el.priority_code.trim()}`}
                  key={index}
                />
              );
            })}
          </ChipsDirective>
        </ChipListComponent>
      </div>
    );
  };
  const resetDataFunction = () => {
    dispatch(changeResetDataLoadingBoolenValue());
    setResetData(false);
    SyncFullOperations(timezone_offset)
      .then((result) => {
        if (result.status == 200) {
          toast.update(resetDataToastinId, {
            render: 'All is good',
            type: 'success',
            isLoading: false,
          });
          Message.success('Synced successfully...');
          dispatch(changeResetDataLoadingBoolenValue());
        }
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Sync failed!!!');
      });
  };

  const isChipClicked2 = (e: any) => {
    if (e.selected) {
      selectedChips.push(e.index + 1);
      selectedChipValues.push(e.index);
    } else {
      selectedChips.splice(selectedChips.indexOf(e.index + 1), 1);
      selectedChipValues.splice(selectedChipValues.indexOf(e.index), 1);
    }
    buildQuery('');
  };
  const template = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          alignSelf: 'flex-end',
          height: 25,
        }}
      >
        <TextBoxComponent
          type={'text'}
          id='work_orders'
          autocomplete='off'
          input={inputEnterPress.bind(this)}
          showClearButton
          placeholder='Search'
          value={searchText}
          onChange={(args: any) => {
            searchText = args.target.value;
          }}
        />
        <div
          style={{
            borderRightColor: 'transparent',
            borderTopColor: 'transparent',
            borderBottomColor: 'transparent',
          }}
        >
          <BsSearch
            color={context.isDarkMode ? '#eaeaea' : '#292525'}
            className={'searchIcon'}
            onClick={search.bind(this)}
          />
        </div>
      </div>
    );
  };
  const toolbarOptions: any = [
    { template: template.bind(this), align: 'Left' },
    'Add',
    // 'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-repeat',
      id: 'refresh',
    },
    {
      text: 'Changes',
      tooltipText: 'Changes',
      id: 'changes',
    },
    {
      text: 'Commit to ERP',
      tooltipText: '',
      id: 'commit',
      visible: ERP_TYPE === erpTypeName ? false : true,
    },

    {
      text: 'Commit To Erp',
      tooltipText: '',
      id: 'commit_mex',
      visible: ERP_TYPE === erpTypeName ? true : false,
    },
    {
      text: 'Apply Template',
      tooltipText: '',
      id: 'apply_template',
    },
    {
      text: 'Apply Default Template',
      tooltipText: '',
      id: 'apply_default_template',
    },
    {
      text: 'Show Operations',
      tooltipText: '',
      id: 'show_operations',
    },
    {
      text: 'Show Resources',
      tooltipText: '',
      id: 'show_resources',
    },
    {
      text: 'Edit',
      tooltipText: '',
      id: 'mass_edit',
    },
    {
      text: 'Sync From ERP',
      tooltipText: '',
      id: 'sync_from_erp',
      visible: ERP_TYPE === erpTypeName ? false : true,
    },
    {
      text: 'Refresh WO',
      tooltipText: '',
      id: 'sync_from_mex',
      visible: ERP_TYPE === erpTypeName ? true : false,
    },
    {
      text: 'Get New Data',
      tooltipText: '',
      id: 'fetchRecords_from_erp',
      visible: ERP_TYPE === erpTypeName ? true : false,
    },
    {
      text: 'Get New Data',
      tooltipText: '',
      id: 'fetchRecords_from_pronto',
      visible: ERP_TYPE === erpTypeName ? false : true,
    },
    // {
    //   text: 'Reset Data',
    //   tooltipText: '',
    //   id: 'sync_full',
    //   visible: ERP_TYPE === erpTypeName ? true : false,
    // },
    {
      text: 'Assign WO',
      tooltipText: '',
      id: 'assign_order',
      visible: true,
    },
    { template: priorityColorChip.bind(this), align: 'Right' },
    'ColumnChooser',
  ];
  const contextMenuItems = [
    {
      text: 'View Order Attachments',
      tooltipText: 'view',
      prefixIcon: 'e-view',
      id: 'view',
    },
    {
      text: 'Show Materials',
      tooltipText: 'view',
      prefixIcon: 'e-view',
      id: 'materials',
    },
  ];

  let priorityFMSComValue: Array<any> = [];
  let departmentFMSComValue: Array<any> = [];
  let sectionFMSComValue: Array<any> = [];
  let prontoReferenceFMSComValue: Array<any> = [];
  let holdReasonFMSComValue: Array<any> = [];
  let statusFMSComValue: Array<any> = [];
  let typeFMSComValue: Array<any> = [];
  let respFMSComValue: Array<any> = [];
  // let referenceFMSComValue: string = '';
  const [referenceFMSComValue, setreferenceFMSComValue] = useState<string>('');
  let workorderCodeFMSComValue: string = '';
  let ScheduleNumberFMSComValue: string = '';
  let assetFMSComValue: string = '';
  let queryOfAsset = new Query().take(20);
  let statusFMSCom: MultiSelectC = new MultiSelectC({});
  let departmentFMSCom: MultiSelectC = new MultiSelectC({});
  let sectionFMSCom: MultiSelectC = new MultiSelectC({});
  let prontoReferenceFMSCom: MultiSelectC = new MultiSelectC({});
  let holdReasonFMSCom: MultiSelectC = new MultiSelectC({});
  let typeFMSCom: MultiSelectC = new MultiSelectC({});
  let respFMSCom: MultiSelectC = new MultiSelectC({});
  let priorityFMSCom: MultiSelectC = new MultiSelectC({});
  let assetFMSCom: TextBoxComponent = new TextBoxComponent({});
  let referenceFMSCom: TextBoxComponent = new TextBoxComponent({});
  let workorderCodeFMSCom: TextBoxComponent = new TextBoxComponent({});
  let ScheduleNumberFMSCom: TextBoxComponent = new TextBoxComponent({});
  const inputEnterPress = (e: any) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      search();
    }
  };
  const buildQuery = (additionalQuery: string) => {
    the_current_query = the_current_query.trimEnd();

    the_current_query = the_current_query.replace(theQueryPrioritys, '');
    the_current_query = the_current_query.replace(theQueryAsset, '');
    the_current_query = the_current_query.replace(theQueryOutterAsset, '');
    the_current_query = the_current_query.replace(theQueryDate, '');
    the_current_query = the_current_query.replace(theQueryResp, '');
    the_current_query = the_current_query.replace(theQueryStatuses, '');
    the_current_query = the_current_query.replace(theQueryType, '');
    the_current_query = the_current_query.replace(theQuerySearch, '');
    the_current_query = the_current_query.replace(theQueryPlanId, '');
    the_current_query = the_current_query.replace(theQueryReference, '');
    the_current_query = the_current_query.replace(theQueryWorkOrderCode, '');
    the_current_query = the_current_query.replace(theQueryScheduleNumber, '');
    the_current_query = the_current_query.replace(theQueryDepartment, '');
    the_current_query = the_current_query.replace(theQuerySection, '');
    the_current_query = the_current_query.replace(theQueryProntoReference, '');
    the_current_query = the_current_query.replace(theQueryHoldReason, '');

    var o_asset_code = outter_asset_code;
    theQueryDepartment = '';
    theQuerySection = '';
    theQueryProntoReference = '';
    theQueryHoldReason = '';
    theQueryPrioritys = '';
    theQueryStatuses = '';
    theQueryAsset = '';
    theQueryResp = '';
    theQueryType = '';
    theQueryDate = '';
    theQuerySearch = '';
    theQueryOutterAsset = '';
    theQueryReference = '';
    theQueryWorkOrderCode = '';
    theQueryScheduleNumber = '';

    var thePrioritysMerged = selectedChips.concat(priorityFMSComValue);
    var thePurePrioritys = [...new Set(thePrioritysMerged)];
    var thePrioritys = thePurePrioritys?.toString();

    var theDepartment = departmentFMSCom?.value?.toString();
    var theSection = sectionFMSCom?.value?.toString();
    var theProntoReference = prontoReferenceFMSCom?.value?.toString();
    var theHoldReason = holdReasonFMSCom?.value?.toString();

    var theStatuses = statusFMSCom?.value?.toString();

    var theTypes = typeFMSCom?.value?.toString();
    var theResp = respFMSCom?.value?.toString();

    var theReference = referenceFMSCom?.value?.toString();
    var theworkorderCode = workorderCodeFMSCom?.value?.toString();
    var theScheduleNumber = ScheduleNumberFMSCom?.value?.toString();

    var theDate = schdeduleStartDateVal;
    var theAssets = assetFMSCom?.value?.toString();

    if (theScheduleNumber === '' || theScheduleNumber === undefined) {
      var theScheduleNumberFromLocalStorage = localStorage.getItem(
        'textboxPMSchedulerNumberTextComponent'
      );
      if (theScheduleNumberFromLocalStorage) {
        theScheduleNumber = extractNumbers(theScheduleNumberFromLocalStorage);
      }
    }

    if (theScheduleNumber !== '' && theScheduleNumber !== undefined) {
      if (the_current_query !== '') {
        theQueryScheduleNumber = addToQuery(
          'pm_schedule_number',
          'in',
          'andWhere',
          theScheduleNumber?.toString()
        );
      } else {
        theQueryScheduleNumber = addToQuery(
          'pm_schedule_number',
          'in',
          'where',
          theScheduleNumber?.toString()
        );
      }
      the_current_query += theQueryScheduleNumber;
    }

    if (theworkorderCode === '' || theworkorderCode === undefined) {
      var theScheduleWorkorderFromLocalStorage = localStorage.getItem(
        'textboxWorkOrderTextBox'
      );
      if (theScheduleWorkorderFromLocalStorage) {
        theworkorderCode = extractNumbers(theScheduleWorkorderFromLocalStorage);
      }
    }

    if (theworkorderCode !== '' && theworkorderCode !== undefined) {
      if (the_current_query !== '') {
        theQueryWorkOrderCode = addToQuery(
          'order_code',
          'in',
          'andWhere',
          theworkorderCode?.toString()
        );
      } else {
        theQueryWorkOrderCode = addToQuery(
          'order_code',
          'in',
          'where',
          theworkorderCode?.toString()
        );
      }
      the_current_query += theQueryWorkOrderCode;
    }

    if (theDepartment !== '' && theDepartment !== undefined) {
      var thDepartmentFromLocalStorage = localStorage.getItem(
        'multiselectDepartmentordersFilterMultiPriority'
      );
      var thDepartmentFromLocalStorageString = extractCharacters(
        thDepartmentFromLocalStorage
      ).join(',');
      theDepartment = thDepartmentFromLocalStorageString;
    }

    if (theDepartment !== '' && theDepartment !== undefined) {
      if (the_current_query !== '') {
        theQueryDepartment = addToQuery(
          'department_id',
          'in',
          'andWhere',
          theDepartment?.toString()
        );
      } else {
        theQueryDepartment = addToQuery(
          'department_id',
          'in',
          'where',
          theDepartment?.toString()
        );
      }
      the_current_query += theQueryDepartment;
    }
    if (theSection !== '' && theSection !== undefined) {
      if (the_current_query !== '') {
        theQuerySection = addToQuery(
          'order_section_code',
          'in',
          'andWhere',
          theSection?.toString()
        );
      } else {
        theQuerySection = addToQuery(
          'order_section_code',
          'in',
          'where',
          theSection?.toString()
        );
      }
      the_current_query += theQuerySection;
    }
    if (theProntoReference !== '' && theProntoReference !== undefined) {
      if (the_current_query !== '') {
        theQueryProntoReference = addToQuery(
          'site_details_1',
          'in',
          'andWhere',
          theProntoReference?.toString()
        );
      } else {
        theQueryProntoReference = addToQuery(
          'site_details_1',
          'in',
          'where',
          theProntoReference?.toString()
        );
      }
      the_current_query += theQueryProntoReference;
    }
    if (theHoldReason !== '' && theProntoReference !== undefined) {
      if (the_current_query !== '') {
        theQueryHoldReason = addToQuery(
          'reason',
          'in',
          'andWhere',
          theHoldReason?.toString()
        );
      } else {
        theQueryHoldReason = addToQuery(
          'reason',
          'in',
          'where',
          theHoldReason?.toString()
        );
      }
      the_current_query += theQueryHoldReason;
    }
    if (thePrioritys == '' || thePrioritys == undefined) {
      var thPriorityFromLocalStorage = localStorage.getItem(
        'multiselectordersFilterMultiPriority'
      );
      var thPriorityFromLocalStorageString = extractCharacters(
        thPriorityFromLocalStorage
      ).join(',');
      thePrioritys = thPriorityFromLocalStorageString;
    }
    if (thePrioritys !== '' && thePrioritys !== undefined) {
      if (the_current_query !== '') {
        theQueryPrioritys = addToQuery(
          'priority_code',
          'in',
          'andWhere',
          thePrioritys?.toString()
        );
      } else {
        theQueryPrioritys = addToQuery(
          'priority_code',
          'in',
          'where',
          thePrioritys?.toString()
        );
      }
      the_current_query += theQueryPrioritys;
    }

    if (theStatuses == '' || theStatuses == undefined) {
      var thStatusFromLocalStorage = localStorage.getItem(
        'multiselectordersFilterMultiStatus'
      );
      var thStatusFromLocalStorageString = extractCharacters(
        thStatusFromLocalStorage
      ).join(',');
      theStatuses = thStatusFromLocalStorageString;
    }
    if (erpTypeName === ERP_TYPE) {
      if (theStatuses !== '' && theStatuses !== undefined) {
        if (the_current_query !== '') {
          theQueryStatuses = addToQuery(
            'status_id',
            'in',
            'andWhere',
            theStatuses?.toString()
          );
        } else {
          theQueryStatuses = addToQuery(
            'status_id',
            'in',
            'where',
            theStatuses?.toString()
          );
        }
        the_current_query += theQueryStatuses;
      }
    } else {
      if (theStatuses !== '' && theStatuses !== undefined) {
        if (the_current_query !== '') {
          theQueryStatuses = addToQuery(
            'status_code',
            'in',
            'andWhere',
            theStatuses?.toString()
          );
        } else {
          theQueryStatuses = addToQuery(
            'status_code',
            'in',
            'where',
            theStatuses?.toString()
          );
        }
        the_current_query += theQueryStatuses;
      }
    }

    if (reduxSearchS.planId !== 0) {
      if (the_current_query !== '') {
        theQueryPlanId = addToQuery(
          'ID',
          '=',
          'andWhere',
          reduxSearchS.planId?.toString()
        );
      } else {
        theQueryPlanId = addToQuery(
          'ID',
          '=',
          'where',
          reduxSearchS.planId?.toString()
        );
      }
      the_current_query += theQueryPlanId;
    }

    if (theAssets === '' || theAssets === undefined) {
      var theAssetFromLocalStorage = localStorage.getItem(
        'textboxAssetTextBox'
      );
      if (theAssetFromLocalStorage) {
        theAssets = extractStringValue(theAssetFromLocalStorage);
      }
    }
    if (theAssets !== '' && theAssets !== undefined) {
      if (the_current_query !== '') {
        theQueryAsset = addToQuery(
          'asset_code',
          'in',
          'andWhere',
          theAssets?.toString()
        );
      } else {
        theQueryAsset = addToQuery(
          'asset_code',
          'in',
          'where',
          theAssets?.toString()
        );
      }
      the_current_query += theQueryAsset;
    }
    if (theTypes == '' || theTypes == undefined) {
      var theTypeFromLocalStorage = localStorage.getItem(
        'multiselectoperationFilterMultiType'
      );
      var theTypeFromLocalStorageString = extractCharacters(
        theTypeFromLocalStorage
      ).join(',');
      theTypes = theTypeFromLocalStorageString;
    }
    if (erpTypeName === ERP_TYPE) {
      if (theTypes !== '' && theTypes !== undefined) {
        if (the_current_query !== '') {
          theQueryType = addToQuery(
            'type_id',
            'in',
            'andWhere',
            theTypes?.toString()
          );
        } else {
          theQueryType = addToQuery(
            'type_id',
            'in',
            'where',
            theTypes?.toString()
          );
        }
  
        the_current_query += theQueryType;
      }  
    } else {
      if (theTypes !== '' && theTypes !== undefined) {
        if (the_current_query !== '') {
          theQueryType = addToQuery(
            'type_code',
            'in',
            'andWhere',
            theTypes?.toString()
          );
        } else {
          theQueryType = addToQuery(
            'type_code',
            'in',
            'where',
            theTypes?.toString()
          );
        }
        the_current_query += theQueryType;
      }
    }
    
    if (theResp !== '' && theResp !== undefined) {
      if (the_current_query !== '') {
        theQueryResp = addToQuery(
          'order_resp_code',
          'in',
          'andWhere',
          theResp?.toString()
        );
      } else {
        theQueryResp = addToQuery(
          'order_resp_code',
          'in',
          'where',
          theResp?.toString()
        );
      }
      the_current_query += theQueryResp;
    }
    if (theReference === '' || theReference === undefined) {
      var theReferenceFromLocalStorage = localStorage.getItem(
        'textboxReferenceTextBox'
      );
      if (theReferenceFromLocalStorage) {
        theReference = extractStringValue(theReferenceFromLocalStorage);
      }
    }

    if (theReference !== '' && theReference !== undefined) {
      if (the_current_query !== '') {
        theQueryReference = addToQuery(
          'site_details_1',
          'in',
          'andWhere',
          theReference?.toString()
        );
      } else {
        theQueryReference = addToQuery(
          'site_details_1',
          'in',
          'where',
          theReference?.toString()
        );
      }
      the_current_query += theQueryReference;
    }

    if (theDate !== null && theDate) {
      if (theDate.length > 0) {
        if (the_current_query !== '') {
          // var start_date = moment(theDate[0]).format('yyyy-MM-DD');
          // var end_date = moment(theDate[1]).format('yyyy-MM-DD');

          var start_date = new Date(
            new Date(theDate[0]).getTime() -
            600 * 60 * 1000 -
            new Date().getTimezoneOffset() * 60 * 1000
          ).toISOString();
          var end_date = new Date(
            new Date(theDate[1].setHours(13, 59, 59)).getTime() -
            new Date().getTimezoneOffset() * 60 * 1000
          ).toISOString();

          theQueryDate = addToQuery(
            'scheduled_start_date',
            '>=',
            'andWhere',
            start_date
          );
          theQueryDate += addToQuery(
            'scheduled_start_date',
            '<=',
            'andWhere',
            end_date
          );
        } else {
          // var start_date = moment(theDate[0]).format('yyyy-MM-DD');
          // var end_date = moment(theDate[1]).format('yyyy-MM-DD');

          var start_date = new Date(
            new Date(theDate[0]).getTime() -
            600 * 60 * 1000 -
            new Date().getTimezoneOffset() * 60 * 1000
          ).toISOString();

          var end_date = new Date(
            new Date(theDate[1].setHours(13, 59, 59)).getTime() -
            new Date().getTimezoneOffset() * 60 * 1000
          ).toISOString();
          theQueryDate = addToQuery(
            'scheduled_start_date',
            '>=',
            'where',
            start_date
          );
          theQueryDate += addToQuery(
            'scheduled_start_date',
            '<=',
            'andWhere',
            end_date
          );
        }
        the_current_query += theQueryDate;
      }
    }
    if (o_asset_code !== '' && o_asset_code !== undefined) {
      if (the_current_query !== '') {
        theQueryOutterAsset = addToQuery(
          'asset_code',
          'in',
          'andWhere',
          o_asset_code.trim()
        );
      } else {
        theQueryOutterAsset = addToQuery(
          'asset_code',
          'in',
          'where',
          o_asset_code.trim()
        );
      }
      the_current_query += theQueryOutterAsset;
    }
    if (searchText !== '' && searchText) {
      theQuerySearch = '$' + searchText;
      the_current_query = the_current_query + theQuerySearch;
    }

    //setLoadSignal(true);
    setCurrentQuery(the_current_query + ' ' + additionalQuery);
    dispatch(
      setIsPlanSelected({
        isOrderPlanSelected: false,
        isOpPlanSelected: reduxSearchS.isOpPlanSelected,
        planId: reduxSearchS.planId,
      })
    );
    dispatch(setSearchCaseOrder(''));
    refreshGridFunction();
  };

  const search = () => {
    if (searchText === '') {
      dispatch(setSearchCaseOrder(''));
    }
    if (searchText !== '' || current_query !== '') {
      buildQuery('');
    }
  };
  const toolbarClickExtends = async (args: any) => {
    if (args.item.id === 'refresh') {
      loadingShow(true, 'Loading...');
      loadingShow(true, 'Loading...');
    }

    if (args.item.id === 'commit') {
      if (gridCPWorkorder?.getSelectedRecords().length > 0) {
        let theTableName = await GetTablenameFromTask('work order');
        if (theTableName === '') {
          theTableName = 'job5mfc';
        } else {
          theTableName = theTableName.trim();
          let theValue = theTableName.split(' ');
          theTableName = theValue[theValue.length - 1];
        }
        var theQuery = '';
        let theDatas = gridCPWorkorder?.getSelectedRecords();
        theDatas.map((theData: any) => {
          theQuery += `update ${theTableName} set 
           cost_description='${theData.description}'
          , jcm_status='${theData.status_code}'
          , jcm_project_type='${theData.type_code}'
          , jcm_file_status='${theData.priority_code}'
          , plant_asset_no='${theData.asset_code}'
          , parent_job='${theData.asset_code_parent}'
          , our_reference='${theData.order_section_code}'
          , jcm_rep_code='${theData.order_resp_code}'
          , job_branch='${theData.order_branch}'
          , cust_reference='${theData.pm_schedule_id}'
          , site_details_1='${theData.site_details_1}'
          , site_details_2='${theData.site_details_2}'
          , site_details_3='${theData.site_details_3}'
          , jcm_start_date=TO_DATE('${moment(
            theData.scheduled_start_date
          ).format('yyyy-MM-DD HH:mm')}', "%Y-%m-%d %H:%M")
          , jcm_start_time=TO_DATE('${moment(theData.scheduledStartTime).format(
            'yyyy-MM-DD HH:mm'
          )}', "%Y-%m-%d %H:%M")
         , jcm_entered_by='${theData.planned_by}'
          where row_id=${theData.pronto_row_id}; `;
          theQuery += ` update jobwodt3 set 
          jobwodt3.est_finish_date=TO_DATE('${moment(
            theData.scheduled_end_date
          ).format('yyyy-MM-DD HH:mm')}', "%Y-%m-%d %H:%M")
         , jobwodt3.est_finish_time=TO_DATE('${moment(
            theData.scheduledEndTime
          ).format('yyyy-MM-DD HH:mm')}', "%Y-%m-%d %H:%M")
          where job_code='${theData.order_code}'; `;
        });
        SendRequest(theQuery, '', calbackFromQueryRequest);
      }
    }
    if (args.item.id === 'sync_from_erp') {
      if (gridCPWorkorder?.getSelectedRecords().length > 0) {
        let theTableName = await GetTablenameFromTask('work order');
        if (theTableName === '') {
          theTableName = 'job5mfc';
        } else {
          theTableName = theTableName.trim();
          let theValue = theTableName.split(' ');
          theTableName = theValue[theValue.length - 1];
        }
        let theRowIds = gridCPWorkorder
          .getSelectedRecords()
          .map((x: any) => x.pronto_row_id)
          .toString();
        let theQuery = `Select  
        LTRIM(UPPER(cost_description)) as description,
        jcm_status as status_code,
        jcm_project_type as type_code,
        jcm_file_status as priority_code,
        plant_asset_no as asset_code,
        parent_job as asset_code_parent,
        our_reference as order_section_code,
        jcm_rep_code as order_resp_code,
        job_branch as order_branch,
        cust_reference as pm_schedule_id,
        site_details_1 as site_details_1,
        site_details_2 as site_details_2,
        site_details_3 as site_details_3,
        jcm_entered_by as planned_by,
        job5mfj.row_id as pronto_row_id,
        job5mfj.job_code as order_code,
        jcm_start_date as scheduled_start_date,
        jcm_start_time as scheduled_start_time,
        jobwodt3.est_finish_date as scheduled_end_date,
        jobwodt3.est_finish_time as scheduled_end_time
        from ${theTableName}
        left outer join jobwodt3 on
        jobwodt3.job_code = job5mfj.job_code
        where job5mfj.row_id in (${theRowIds});`;
        Message.info('Please wait for the response. It may take a while');
        let count: number = 11;
        let interval = setInterval(() => {
          count--;
          loadingShow(true, 'Checking... ' + count + ' seconds');
          if (count === 0) {
            clearInterval(interval);
            isAgentAlive = false;
            Message.info('No response to procced. Please try again later.');
            loadingShow(false);
          }
          if (isAgentAlive) {
            clearInterval(interval);
            isAgentAlive = false;
            loadingShow(false);
            Message.success('Seems like the agent is alive');
          }
        }, 1000);
        SendRequest(theQuery, 'SYNCED', undefined, true);
      }
    }

    if (args.item.id === 'sync_from_mex') {
      if (gridCPWorkorder?.getSelectedRecords().length > 0) {
        let theTableName = await GetTablenameFromTask('work order');
        if (theTableName === '') {
          theTableName = 'job5mfc';
        } else {
          theTableName = theTableName.trim();
          let theValue = theTableName.split(' ');
          theTableName = theValue[theValue.length - 1];
        }
        var theQuery = '';
        let theDatas: any = gridCPWorkorder?.getSelectedRecords();

        theDatas.map((item: any) => {
          item.scheduled_start_date = item?.scheduled_start_date?.toString();
        });
        loadingShow(true, 'Loading...');

        SyncFromMex(theDatas, timezone_offset)
          .then((result: AxiosResponse) => {
            if (result.status == 200) {
              loadingShow(false);
              Message.success('Synced successfully...');
              buildQuery('');
            }
          })
          .catch((err) => {
            loadingShow(false);
            Message.error('Sync failed!!!');
          });
      }
    }
    if (args.item.id === 'sync_full') {
      if (isResetDataLoading || isDataResettingComponentHandle) {
        Message.error('Data is resetting...');
      } else {
        setResetData(true);
      }
    }
    if (args.item.id === 'fetchRecords_from_erp') {
      setQuestionDialog(true);
    }
    if (args.item.id === 'fetchRecords_from_pronto') {
      let result = await GetMaxProntoRowIdData();
      let maxProntoRowId;
      if (result.status === 200) {
        maxProntoRowId = result.data;
      }

      let theTableName = await GetTablenameFromTask('work order');
      if (theTableName === '') {
        theTableName = 'job5mfc';
      } else {
        theTableName = theTableName.trim();
        let theValue = theTableName.split(' ');
        theTableName = theValue[theValue.length - 1];
      }
      // let theRowIds = gridCPWorkorder
      //   .getSelectedRecords()
      //   .map((x: any) => x.pronto_row_id)
      //   .toString();
      let theQuery = `Select  
      cost_description as description,
      jcm_status as status_code,
      jcm_project_type as type_code,
      jcm_file_status as priority_code,
      plant_asset_no as asset_code,
      parent_job as asset_code_parent,
      our_reference as order_section_code,
      jcm_rep_code as order_resp_code,
      job_branch as order_branch,
      cust_reference as pm_schedule_id,
      site_details_1 as site_details_1,
      site_details_2 as site_details_2,
      site_details_3 as site_details_3,
      jcm_entered_by as planned_by,
      row_id as pronto_row_id,
      job_code as order_code
      from ${theTableName} where row_id > (${maxProntoRowId});`;
      Message.info('Please wait for the response. It may take a while');
      let count: number = 11;
      let interval = setInterval(() => {
        count--;
        loadingShow(true, 'Checking... ' + count + ' seconds');
        if (count === 0) {
          clearInterval(interval);
          isAgentAlive = false;
          Message.info('No response to procced. Please try again later.');
          loadingShow(false);
        }
        if (isAgentAlive) {
          clearInterval(interval);
          isAgentAlive = false;
          loadingShow(false);
          Message.success('Seems like the agent is alive');
        }
      }, 1000);
      SendRequest(theQuery, 'SYNCED_NEW_RECORDS', undefined, true);
    }
    if (args.item.id === 'assign_order') {
      if (gridCPWorkorder?.getSelectedRecords().length > 0) {
        let theDatas = gridCPWorkorder?.getSelectedRecords() as any;
        setTheDatas(theDatas);
        setHideDialogEventPlan(true);
      } else {
        Message.error('Select a Work Order...');
      }
    }

    if (args.item.id === 'changes') {
      if (clickTimes === 0) {
        setGridGetQuery('mex-order');
        setCurrentQuery(`/changes`);
        setClickTimes(1);
      } else {
        setGridGetQuery('order');
        buildQuery('');
        setClickTimes(0);
      }
    }

    if (args.item.id === 'commit_mex') {
      setcommitToErpClicked(true);
    }

    if (args.item.id === 'apply_template') {
      if (gridCPWorkorder?.getSelectedRecords().length > 0) {
        let theDatas = gridCPWorkorder?.getSelectedRecords() as any;
        setOrderDetail(theDatas);

        setShowTemplateDialog(true);
      }
    }
    if (args.item.id === 'show_operations') {
      if (gridCPWorkorder?.getSelectedRecords().length > 0) {
        let theDatas = gridCPWorkorder?.getSelectedRecords();
        let theCodes = theDatas
          .map((theData: any) => {
            return theData.order_code;
          })
          .toString();
        dispatch(setSearchCaseOp(theCodes));
        dispatch(setSearchCaseOrder(''));
      }
    }
    if (args.item.id === 'show_resources') {
      if (gridCPWorkorder?.getSelectedRecords().length > 0) {
        let theDatas = gridCPWorkorder?.getSelectedRecords();
        let theCodes = theDatas
          .map((theData: any) => {
            return theData.order_code;
          })
          .toString();
        dispatch(setSearchCaseGantt(theCodes));
      }
    }
    if (args.item.id === 'mass_edit') {
      if (gridCPWorkorder?.getSelectedRecords().length > 0) {
        setMassiveEditDialog(true);
      }
    }
    if (args.item.id === 'apply_default_template') {
      if (gridCPWorkorder?.getSelectedRecords().length > 0) {
        let theDatas: any[] = [];
        let theData: any = gridCPWorkorder?.getSelectedRecords()[0] as any;
        theDatas.push(theData);

        if (
          theDatas[0]?.pm_schedule_id === undefined ||
          theDatas[0]?.pm_schedule_id === ''
        ) {
          Message.info('There is no PM Schedule ID');
          return;
        }
        preparingTemplatePoint(theDatas, theDatas[0].pm_schedule_id);
      }
    }
  };
  const calbackFromQueryRequest = (args: any) => {
    if (gridCPWorkorder?.getSelectedRecords().length > 0) {
      let theDatas = gridCPWorkorder?.getSelectedRecords();
      theDatas = theDatas.map((theData: any) => {
        return { ...theData, isEffected: false };
      });

      if (ERP_TYPE === 'MEX') {
        const differenceOffsetMillis = serverOffsetMillis - localOffsetMillis;

        theDatas.map((item: any) => {
          item.scheduled_start_date = new Date(
            new Date(item.scheduled_start_date)?.getTime() +
            differenceOffsetMillis
          ).toString();
          item.scheduled_end_date = new Date(
            new Date(item.scheduled_end_date)?.getTime() +
            differenceOffsetMillis
          ).toString();
        });
      }
      EditWorkOrder(theDatas, -timezone_offset)
        .then((res) => {
          Message.success('Success');
          buildQuery(' ');
        })
        .catch((er) => {
          Message.error('Error occured');
        });
    }
  };
  const queryCellInfo = (args: QueryCellInfoEventArgs) => {
    if (
      args.column &&
      args.column.type === 'checkbox' &&
      args.data &&
      args.cell
    ) {
      let theData = args.data as any;
      if (theData) {
        let isEffected = theData.isEffected;
        let theCurrenColor = 'tranparent';
        if (isEffected) {
          theCurrenColor = '#8ECDDD';
        }
        args.cell.setAttribute('style', `background-color:${theCurrenColor};`);
      }
    }
  };
  const priorityColor = (args: any) => {
    let color = PriorityColorData.find(
      (x: any) => x.priority_code?.trim() === args.priority_code?.trim()
    )?.priority_color;
    return (
      <div
        style={{
          backgroundColor: color,
          borderRadius: 7,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <span>{args.priority_code}</span>
      </div>
    );
  };
  const materialColor = (args: any) => {
    return (
      <div
        style={{
          backgroundColor: args.material_status,
          borderRadius: 7,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '20px',
        }}
      >
        <span> </span>
      </div>
    );
  };
  const contextMenuClick = (args: any) => {
    if (args.item.id === 'view') {
      const data = gridCPWorkorder?.getSelectedRecords()[0] as any;
      if (data.order_code) {
        setCurrentWOC(data.order_code);
        setHideAddDialog(true);
      } else {
        Message.info('There is no order to transiction');
      }
    }
    if (args.item.id === 'materials') {
      const data = gridCPWorkorder?.getSelectedRecords()[0] as any;
      if (data.order_code) {
        g_worder = data.order_code;
      } else {
        Message.info('There is no order to transiction');
        return;
      }
      context.setTabChangeMaterials(true);
      context.setDataChangeMaterials(true);
    }
  };

  // const durationTemplate = (args: any) => {
  //   const startDate = new Date(args.scheduled_start_date);
  //   const endDate = new Date(args.scheduled_end_date);

  //   let difference = endDate.getTime() - startDate.getTime();

  //   let differenceAsDays = Math.round(difference / (1000 * 3600));
  //   return (
  //     <div>
  //       {differenceAsDays > 0 ? (
  //         <div>
  //           <span>{differenceAsDays}</span>
  //         </div>
  //       ) : (
  //         <></>
  //       )}
  //     </div>
  //   );
  // };
  const isAttachmentsTemplate = (args: any) => {
    const data = undefined;
    return (
      <div>
        {data !== undefined ? (
          <div>
            <span>{args.order_code}</span>
            <AiOutlinePaperClip color='#999999' size={17} />
          </div>
        ) : (
          <div>
            <span>{args.order_code}</span>
          </div>
        )}
      </div>
    );
  };
  const clearFilter = () => {
    departmentFMSCom.value = [];
    sectionFMSCom.value = [];
    prontoReferenceFMSCom.value = [];
    holdReasonFMSCom.value = [];
    workorderCodeFMSCom.value = '';
    statusFMSCom.value = [];
    referenceFMSCom.value = '';
    assetFMSCom.value = '';
    typeFMSCom.value = [];
    respFMSCom.value = [];
    priorityFMSCom.value = [];
    ScheduleNumberFMSCom.value = '';

    ScheduleNumberFMSComValue = '';
    chips.selectedChips = [];
    priorityFMSComValue = [];
    statusFMSComValue = [];
    departmentFMSComValue = [];

    typeFMSComValue = [];
    respFMSComValue = [];
    // referenceFMSComValue = '';
    setreferenceFMSComValue('');
    workorderCodeFMSComValue = '';
    setSchdeduleStartDateVal([]);
    if (current_query !== '') {
      buildQuery('');
    }
  };
  const StatusMultiSelect = () => {
    return (
      <>
        <GlobalMultiSelection
          refDD={(scope: MultiSelectC) => {
            statusFMSCom = scope;
          }}
          field={{ value: 'value', text: 'alias' }}
          id='ordersFilterMultiStatus'
          url='global-filter?where=workorders$status$isEnabled€1'
          placeHolder='Select a Status'
          value={statusFMSComValue}
          onChange={(e: any) => {
            statusFMSComValue = e.value;
          }}
          enablePersistence={true}
        />
      </>
    );
  };
  const PriorityMultiSelect = () => {
    return (
      <>
        <GlobalMultiSelection
          refDD={(scope: MultiSelectC) => {
            priorityFMSCom = scope;
          }}
          field={{ value: 'value', text: 'alias' }}
          id='ordersFilterMultiPriority'
          url='global-filter?where=workorders$priority$isEnabled€1'
          placeHolder='Select a Priority'
          value={priorityFMSComValue}
          onChange={(e: any) => {
            priorityFMSComValue = e.value;
          }}
          enablePersistence={true}
        />
      </>
    );
  };
  const WorkOrderCodeInput = () => {
    return (
      <div>
        {ERP_TYPE === erpTypeName && (
          <TextBoxComponent
            type={'text'}
            ref={(scope: TextBoxComponent) => {
              workorderCodeFMSCom = scope;
            }}
            autocomplete='off'
            enablePersistence={true}
            showClearButton
            id='WorkOrderTextBox'
            placeholder='Work Order'
            value={workorderCodeFMSComValue}
            onChange={(args: any) => {
              workorderCodeFMSComValue = args.target.value;
            }}
          />
        )}
      </div>
    );
  };
  const ScheduleNumberComponent = () => {
    return (
      <div>
        {ERP_TYPE === erpTypeName && (
          <TextBoxComponent
            type={'text'}
            ref={(scope: TextBoxComponent) => {
              ScheduleNumberFMSCom = scope;
            }}
            autocomplete='off'
            id='PMSchedulerNumberTextComponent'
            showClearButton
            placeholder='PM Schedule Number'
            value={ScheduleNumberFMSComValue}
            enablePersistence={true}
            onChange={(args: any) => {
              ScheduleNumberFMSComValue = args.target.value;
            }}
          />
        )}
      </div>
    );
  };
  const DepartmentFilterInput = () => {
    return (
      <>
        <GlobalMultiSelection
          refDD={(scope: MultiSelectC) => {
            departmentFMSCom = scope;
          }}
          field={{ value: 'value', text: 'description' }}
          id='DepartmentordersFilterMultiPriority'
          url='global-filter?where=workorders$department$isEnabled€1&='
          placeHolder='Select a Department'
          value={departmentFMSComValue}
          onChange={(e: any) => {
            departmentFMSComValue = e.value;
          }}
          enablePersistence={true}
        />
      </>
    );
  };
  const SectionFilterInput = () => {
    return (
      <div>
        {ERP_TYPE !== erpTypeName && (
          <GlobalMultiSelection
            refDD={(scope: MultiSelectC) => {
              sectionFMSCom = scope;
            }}
            field={{ value: 'value', text: 'value' }}
            id='SectionordersFilterMulti'
            url='global-filter?where=workorders$section$isEnabled€1&='
            placeHolder='Select a Section'
            value={sectionFMSComValue}
            onChange={(e: any) => {
              sectionFMSComValue = e.value;
            }}
            enablePersistence={true}
          />
        )}
      </div>
    );
  };
  const PontoReferenceFilterInput = () => {
    return (
      <div>
        {ERP_TYPE !== erpTypeName && (
          <GlobalMultiSelection
            refDD={(scope: MultiSelectC) => {
              prontoReferenceFMSCom = scope;
            }}
            field={{ value: 'value', text: 'description' }}
            id='ProntoReferenceOrdersFilterMulti'
            url='global-filter?where=workorders$reference$isEnabled€1&='
            placeHolder='Select a Reference'
            value={prontoReferenceFMSComValue}
            onChange={(e: any) => {
              prontoReferenceFMSComValue = e.value;
            }}
            enablePersistence={true}
          />
        )}
      </div>
    );
  };
  const HoldReasonFilterInput = () => {
    return (
      <div>
        {ERP_TYPE !== erpTypeName && (
          <GlobalMultiSelection
            refDD={(scope: MultiSelectC) => {
              holdReasonFMSCom = scope;
            }}
            field={{ value: 'value', text: 'description' }}
            id='reasonOrdersFilterMulti'
            url='global-filter?where=workorders$reason$isEnabled€1&='
            placeHolder='Select a Hold Reason'
            value={holdReasonFMSComValue}
            onChange={(e: any) => {
              holdReasonFMSComValue = e.value;
            }}
            enablePersistence={true}
          />
        )}
      </div>
    );
  };
  const ReferenceInput = () => {
    return (
      <div>
        {ERP_TYPE === erpTypeName && (
          <TextBoxComponent
            enablePersistence={true}
            type={'text'}
            ref={(scope: TextBoxComponent) => {
              referenceFMSCom = scope;
            }}
            autocomplete='off'
            showClearButton
            placeholder='Reference'
            id='ReferenceTextBox'
            value={referenceFMSComValue}
            onChange={(args: any) => {
              // referenceFMSComValue = args.target.value;
              setreferenceFMSComValue(args.target.value);
            }}
          />
        )}
      </div>
    );
  };
  const AssetInput = () => {
    return (
      <div>
        {ERP_TYPE === erpTypeName && (
          <TextBoxComponent
            type={'text'}
            ref={(scope: TextBoxComponent) => {
              assetFMSCom = scope;
            }}
            autocomplete='off'
            showClearButton
            placeholder='Asset'
            id='AssetTextBox'
            enablePersistence={true}
            value={assetFMSComValue}
            onChange={(args: any) => {
              assetFMSComValue = args.target.value;
            }}
          />
        )}
      </div>
    );
  };
  // const AssetInput = () => {
  //   return (
  //     <>
  //       <GlobalMultiSelection
  //         refDD={(scope: MultiSelectC) => {
  //           assetFMSCom = scope;
  //         }}
  //         query={queryOfAsset}
  //         field={{ text: 'assetCode', value: 'assetCode' }}
  //         placeHolder='Select a Asset'
  //         id='ordersFilterMultiAsset'
  //         url='assets/search'
  //         value={assetFMSComValue}
  //         allowFiltering={true}
  //         onChange={(e: any) => {
  //           assetFMSComValue = e.value;
  //         }}
  //       />
  //     </>
  //   );
  // };
  const TypeInput = () => {
    return (
      <>
        <GlobalMultiSelection
          refDD={(scope: MultiSelectC) => {
            typeFMSCom = scope;
          }}
          //field={{ value: 'sys_tbl_code', text: 'sys_description' }}
          field= {erpTypeName=== ERP_TYPE? { value: 'value', text: 'description' }: { value: 'value', text: 'alias' }}
          id='operationFilterMultiType'
          //url='system-config?where=P3'
          url={'global-filter?where=workorders$type$isEnabled€1'}
          placeHolder='Select a Type'
          value={typeFMSComValue}
          onChange={(e: any) => {
            typeFMSComValue = e.value;
          }}
          enablePersistence={true}
        />
      </>
    );
  };
  //global-filter?where=workorders$type$isEnabled€1
  const RespInput = () => {
    return (
      <>
        {ERP_TYPE !== erpTypeName && (
          <GlobalMultiSelection
            refDD={(scope) => {
              respFMSCom = scope;
            }}
            field={{ value: 'value', text: 'alias' }}
            id='ordersFilterMultiResp'
            //url='system-config?where=P2'
            url='global-filter?where=workorders$responsibility$isEnabled€1'
            placeHolder='Select a Resp'
            onChange={(e) => {
              respFMSComValue = e.value;
            }}
            value={respFMSComValue}
            enablePersistence={true}
          />
        )}
      </>
    );
  };

  const ScheduleStartDateInput = () => {
    return (
      <div>
        <DateRangePickerComponent
          placeholder='Schedule Start Date'
          enabled={true}
          format={'dd/MM/yyyy'}
          showClearButton={true}
          value={schdeduleStartDateVal}
          onChange={(e: any) => {
            setSchdeduleStartDateVal(e.value);
          }}
        ></DateRangePickerComponent>
      </div>
    );
  };
  const FilterPrio = () => {
    buildQuery('');
  };
  const theColumns = [
    {
      field: 'app',
      textAlign: 'Left',
      headerText: 'App',
      width: 80,
      visible: false,
    },
    {
      field: 'order_id',
      textAlign: 'Left',
      headerText: 'Workorder ID',
      width: 80,
      visible: false,
      isPrimaryKey: true,
    },
    {
      field: 'order_code_id',
      textAlign: 'Left',
      headerText: 'Workorder code ID',
      width: 80,
      visible: false,
    },
    {
      field: 'order_code_id',
      textAlign: 'Left',
      headerText: 'Workorder code ID',
      width: 80,
      visible: false,
    },
    {
      field: 'isEffected',
      textAlign: 'Left',
      width: 50,
      visible: false,
      clipMode: 'EllipsisWithTooltip',
      type: 'boolean',
    },

    {
      field: 'priority_code',
      template: priorityColor.bind(this),
      headerText: 'Priority Code',
      width: 130,
      clipMode: 'EllipsisWithTooltip',
      edit: getParamsDD(
        { value: 'value', text: 'alias' },
        'priority_code',
        'global-filter?where=workorders$priority$isEnabled€1',
        true
      ),
    },
    {
      field: 'asset_code_parent',
      headerText: 'Parent Asset',
      visible: false,
      width: 140,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'material_status',
      template: materialColor.bind(this),
      headerText: 'Material Status',
      width: 40,
      visible: ERP_TYPE === erpTypeName ? false : true,
      clipMode: 'EllipsisWithTooltip',
    },

    {
      field: 'asset_code',
      headerText: 'Asset Code',
      width: 150,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'asset_description',
      headerText: 'Asset Description',
      clipMode: 'EllipsisWithTooltip',
      visible: ERP_TYPE === erpTypeName ? true : false,
      allowEditing: true,
    },
    {
      field: 'order_code',
      textAlign: 'Left',
      template: isAttachmentsTemplate.bind(this),
      headerText: 'Workorder Code',
      width: 170,
      isPrimaryKey: true,
      clipMode: 'EllipsisWithTooltip',
    },
    {
      field: 'description',
      headerText: 'Description',
      clipMode: 'EllipsisWithTooltip',
      allowEditing: true,
    },
    {
      field: 'scheduled_start_date',
      headerText: 'Scheduled Start Date',
      width: 200,
      clipMode: 'EllipsisWithTooltip',
      type: 'datetime',
      format: 'dd/MM/yyyy HH:mm:ss',
      allowEditing: false,
    },
    {
      field: 'scheduled_end_date',
      headerText: 'Scheduled End Date',
      width: 200,
      clipMode: 'EllipsisWithTooltip',
      type: 'datetime',
      format: 'dd/MM/yyyy HH:mm:ss',
      editType: 'datetimepickeredit',
      // edit: endDateParams,
      allowEditing: false,
    },
    {
      field: 'duration',
      // template: durationTemplate.bind(this),
      headerText: 'Duration',
      width: 150,
      type: 'number',
      format: '0.00',
    },

    {
      field: 'site_details_1',
      headerText: 'Reference',
      width: 120,
      clipMode: 'EllipsisWithTooltip',
      visible: true,
      allowEditing: false,
      edit:
        ERP_TYPE !== erpTypeName &&
        getParamsDD(
          { value: 'description', text: 'alias' },
          'status_code',
          'global-filter?where=workorders$reference$isEnabled€1',
          true
        ),
    },
    ERP_TYPE == 'MEX'
      ? {
        field: 'pm_schedule_number',
        headerText: 'PM Schedule Number',
        width: 200,
        clipMode: 'EllipsisWithTooltip',
        visible: ERP_TYPE === erpTypeName ? true : false,
      }
      : {
        field: 'pm_schedule_id',
        headerText: 'PM Schedule ID',
        width: 200,
        clipMode: 'EllipsisWithTooltip',
        visible: ERP_TYPE === erpTypeName ? true : false,
      },

    ,
    {
      field: 'department_code',
      headerText: 'Department',
      visible: ERP_TYPE === erpTypeName ? true : false,
      clipMode: 'EllipsisWithTooltip',
      allowEditing: true,
    },
    {
      field: 'status_code',
      headerText: 'Status Code',
      width: 150,
      clipMode: 'EllipsisWithTooltip',
      allowEditing: true,
      edit: getParamsDD(
        erpTypeName === ERP_TYPE ?{ value: 'description', text: 'alias' } :{ value: 'alias', text: 'alias' },
        'status_code',
        'global-filter?where=workorders$status$isEnabled€1',
        true
      ),
    },
    {
      field: 'type_code',
      headerText: 'Type Code',
      width: 120,
      clipMode: 'EllipsisWithTooltip',
      allowEditing: true,
      edit: getParamsDD(
        erpTypeName === ERP_TYPE ?{ value: 'description', text: 'alias' } :{ value: 'alias', text: 'alias' },
        'type_code',
        'global-filter?where=workorders$type$isEnabled€1',
        true
      ),
      // edit: getParamsDD(
      //   { value: 'sys_tbl_code', text: 'sys_description' },
      //   'type_code',
      //   'system-config?where=P3',
      //   true
      // ),
    },
    {
      field: 'reason',
      headerText: 'Hold Reason',
      width: 120,
      clipMode: 'EllipsisWithTooltip',
      allowEditing: true,
      visible: ERP_TYPE === 'PRONTO' ? true : false,
      edit: getParamsDD(
        { value: 'value', text: 'value' },
        'reason',
        'global-filter?where=workorders$reason$isEnabled€1',
        true
      ),
    },
    {
      field: 'planned_start_date',
      headerText: 'Planned Start Time',
      width: 200,
      clipMode: 'EllipsisWithTooltip',
      type: 'datetime',
      format: 'dd/MM/yyyy HH:mm:ss',
      allowEditing: false,
      edit: { params: { format: 'dd/MM/yyyy HH:mm:ss' } },
    },
    {
      field: 'planned_end_date',
      headerText: 'Planned End Time',
      width: 200,
      clipMode: 'EllipsisWithTooltip',
      type: 'datetime',
      format: 'dd/MM/yyyy HH:mm:ss',
      allowEditing: false,
      edit: { params: { format: 'dd/MM/yyyy HH:mm:ss' } },
    },
    {
      field: 'wo_labour_cost',
      headerText: 'Labour Cost',
      width: 150,
      clipMode: 'EllipsisWithTooltip',
      visible: ERP_TYPE === erpTypeName ? true : false,
      allowEditing: true,
      format: 'C2',
    },
    {
      field: 'wo_material_cost',
      headerText: 'Material Cost',
      width: 150,
      clipMode: 'EllipsisWithTooltip',
      visible: ERP_TYPE === erpTypeName ? true : false,
      allowEditing: true,
      format: 'C2',
    },
    {
      field: 'wo_other_cost',
      headerText: 'Other Cost',
      width: 150,
      clipMode: 'EllipsisWithTooltip',
      visible: ERP_TYPE === erpTypeName ? true : false,
      allowEditing: true,
      format: 'C2',
    },
    {
      field: 'order_resp_code',
      headerText: 'Responsibility',
      width: 150,
      visible: ERP_TYPE === erpTypeName ? false : true,
      clipMode: 'EllipsisWithTooltip',
      allowEditing: true,
      edit: getParamsDD(
        { value: 'sys_tbl_code', text: 'sys_description' },
        'order_resp_code',
        'system-config?where=P2',
        true
      ),
    },
    {
      field: 'pm_schedule_id',
      headerText: 'PM Schedule ID',
      width: 150,
      clipMode: 'EllipsisWithTooltip',
      visible: ERP_TYPE === erpTypeName ? false : true,
    },
    // {
    //   field: camelCase('scheduled_start_time'),
    //   fieldSearch: 'scheduled_start_time',
    //   headerText: 'Scheduled Start Time',
    //   width: 150,
    //   clipMode: 'EllipsisWithTooltip',
    //   type: 'datetime',
    //   format: 'HH:mm:ss',
    //   edit: { params: { format: 'dd/MM/yyyy HH:mm:ss' } },
    //   editType: 'datetimepickeredit',
    //   allowEditing: false,
    // },

    // {
    //   field: camelCase('scheduled_end_time'),
    //   fieldSearch: 'scheduled_end_time',
    //   headerText: 'Scheduled End Time',
    //   width: 150,
    //   clipMode: 'EllipsisWithTooltip',
    //   type: 'datetime',
    //   format: 'HH:mm:ss',
    //   editType: 'datetimepickeredit',
    //   edit: { params: { format: 'dd/MM/yyyy HH:mm:ss' } },
    //   allowEditing: false,
    // },

    {
      field: 'duration',
      // template: durationTemplate.bind(this),
      headerText: 'Planned Duration',
      width: 150,
      visible: false,
      format: '0.00',
    },

    {
      field: 'actual_start_date',
      headerText: 'Actual Start Date',
      width: 200,
      clipMode: 'EllipsisWithTooltip',
      type: 'datetime',
      format: 'dd/MM/yyyy HH:mm:ss',
      allowEditing: false,
      edit: { params: { format: 'dd/MM/yyyy HH:mm:ss' } },
      visible: false,
    },
    {
      field: 'actual_end_date',
      headerText: 'Actual End Time',
      width: 200,
      clipMode: 'EllipsisWithTooltip',
      type: 'datetime',
      format: 'dd/MM/yyyy HH:mm:ss',
      allowEditing: false,
      edit: { params: { format: 'dd/MM/yyyy HH:mm:ss' } },
      visible: false,
    },

    {
      field: 'creation_date',
      headerText: 'Created Date',
      width: 140,
      clipMode: 'EllipsisWithTooltip',
      type: 'datetime',
      format: 'dd/MM/yyyy HH:mm:ss',
      visible: false,
      allowEditing: false,
    },
    // {
    //   field: 'created_by',
    //   headerText: 'Created By',
    //   width: 140,
    //   clipMode: 'EllipsisWithTooltip',
    //   visible: ERP_TYPE === erpTypeName ? true : false,
    //   allowEditing: false,
    // },
    {
      field: 'custom_txt_field6',
      headerText: 'Created By',
      width: 140,
      clipMode: 'EllipsisWithTooltip',
      visible: false,
      allowEditing: false,
    },

    {
      field: 'order_branch',
      headerText: 'Account Code',
      width: 140,
      clipMode: 'EllipsisWithTooltip',
      visible: false,
      allowEditing: false,
    },
    {
      field: 'mex_order_instruction',
      headerText: 'Instructions',
      visible: false,
      clipMode: 'EllipsisWithTooltip',
      allowEditing: true,
    },
    {
      field: 'mex_order_safety_note',
      headerText: 'Safety Notes',
      visible: false,
      clipMode: 'EllipsisWithTooltip',
      allowEditing: true,
    },
    {
      field: 'team_code',
      headerText: 'Team',
      width: 110,
      visible: ERP_TYPE === erpTypeName ? false : true,
      clipMode: 'EllipsisWithTooltip',
      edit: getParamsDD(
        { text: 'team_code', value: 'team_code' },
        'team_code',
        'team',
        true
      ),
    },
    {
      field: 'shift',
      headerText: 'Shift',
      width: 110,
      visible: ERP_TYPE === erpTypeName ? false : true,
      clipMode: 'EllipsisWithTooltip',
      allowEditing: true,
      edit: getParamsDD(
        { text: 'rosterCode', value: 'rosterId' },
        'shift',
        'shift'
      ),
    },
    {
      field: 'order_section_code',
      headerText: 'Section',
      width: 120,
      visible: ERP_TYPE === erpTypeName ? false : true,
      clipMode: 'EllipsisWithTooltip',
      allowEditing: true,
      edit: getParamsDD(
        { value: 'sys_tbl_code', text: 'sys_description' },
        'order_section_code',
        'system-config?where=N4',
        true
      ),
    },
    {
      field: 'order_branch',
      headerText: 'Branch',
      width: 40,
      visible: ERP_TYPE === erpTypeName ? false : true,
      clipMode: 'EllipsisWithTooltip',
      allowEditing: false,
    },
    {
      field: 'order_branch_id',
      headerText: 'Branch ID',
      width: 40,
      visible: false,
      clipMode: 'EllipsisWithTooltip',
      allowEditing: false,
      ERP_TYPE,
    },
    {
      field: 'site_details_2',
      headerText: 'Site Details 2',
      width: 40,
      clipMode: 'EllipsisWithTooltip',
      visible: false,
      allowEditing: true,
    },
    {
      field: 'site_details_3',
      headerText: 'Site Details 3',
      width: 40,
      clipMode: 'EllipsisWithTooltip',
      visible: false,
      allowEditing: true,
    },
    {
      field: 'entered_by',
      headerText: 'Entered By',
      width: 40,
      visible: ERP_TYPE === erpTypeName ? false : true,
      clipMode: 'EllipsisWithTooltip',
      allowEditing: true,
    },
    {
      field: 'approval_date',
      headerText: 'Approval Date',
      width: 150,
      clipMode: 'EllipsisWithTooltip',
      type: 'datetime',
      format: 'dd/MM/yyyy HH:mm:ss',
      edit: { params: { format: 'dd/MM/yyyy HH:mm:ss' } },
      visible: false,
      allowEditing: true,
    },
  ];
  const onCreated = (grid: GridComponent) => {
    gridCPWorkorder = grid;
    gridCPWorkorder.allowReordering = reduxSearchS.reOrderAble;
    if (gridRef) {
      gridRef(grid);
    }
  };
  useEffect(() => {
    mounted = true;
    socket.on('OnSyncQueryFeedback', (data: any) => {
      isAgentAlive = true;
      let theData = JSON.parse(data);
      let theMessage = theData.request_sql;
      if (theMessage.includes('failed')) {
        Message.error(theMessage);
      } else {
        buildQuery('');
        Message.success(theMessage);
      }
    });
    socket.on('OnGetNewRecordQueryFeedback', (data: any) => {
      isAgentAlive = true;
      let theData = JSON.parse(data);
      let theMessage = theData.request_sql;
      if (theMessage.includes('failed')) {
        Message.error(theMessage);
      } else {
        buildQuery('');
        Message.success(theMessage);
      }
    });
    socket.connect();
    return () => {
      socket.disconnect();
    };
  }, []);
  useEffect(() => {
    if (reduxSearchS.isOrderPlanSelected) {
      const get = async () => {
        let theData = await getPriority();
        setPriorityColorData(theData);
        the_current_query = await applyTheRule('uw_order', 'Cloud Planner');
        buildQuery('');
      };
      get();
    }
  }, [reduxSearchS.isOrderPlanSelected]);
  useEffect(() => {
    $('#work_orders').val(searchText);
    PriorityColorData?.map((elCol: any) => {
      $(`.e-chip-text${elCol.priority_code?.trim()}`).css(
        'background-color',
        `${elCol?.priority_color}`
      );
      var el = document.getElementsByClassName(
        `e-chip-text${elCol.priority_code?.trim()}`
      )[0] as any;
      if (el) {
        el.style.backgroundColor = elCol?.priority_color;
      }
    });
  });
  useEffect(() => {
    if (
      reduxSearchS.theOrSearchFromRedux &&
      reduxSearchS.theOrSearchFromRedux !== ''
    ) {
      $('#order-request').val(reduxSearchS.theOrSearchFromRedux);
      searchText = reduxSearchS.theOrSearchFromRedux;
      buildQuery('');
    }
  }, [reduxSearchS.theOrSearchFromRedux]);
  const massCallBack = async (args: any) => {
    if (gridCPWorkorder) {
      if (gridCPWorkorder?.getSelectedRecords().length > 0) {
        let theDatas = gridCPWorkorder?.getSelectedRecords();
        let theEdittedOp = [];
        loadingShow(true, 'Processing...');
        loadingShow(true, 'Just a second while getting operations....');
        let idList: string[] = [];
        theDatas.map((theData: any) => {
          idList.push(theData.order_code?.toString());
        });

        let theOperations = await getOperations('1$100$$', idList);
        // let theOperations = await getOperations('1$100$$'+
        //   theDatas.map((theData: any)=>{
        //     return theData.order_code;
        //   }).toString()
        // );
        loadingShow(true, 'Operations adjusting....');
        theEdittedOp = theOperations.data.map((theData: any) => {
          if (
            theData.scheduled_start_date === null ||
            theData.scheduled_end_date === null
          ) {
            theData.scheduled_start_date = args.dataOrder.scheduled_start_date;
            theData.scheduled_end_date = args.dataOrder.scheduled_start_date;
          } else {
            if (args.dataOrder.scheduled_start_date) {
              let theDifference = moment(
                args.dataOrder.scheduled_start_date
              ).diff(new Date(theData.scheduled_start_date), 'millisecond');
              theData.scheduled_end_date = moment(theData.scheduled_end_date)
                .add(theDifference, 'millisecond')
                .toDate();
              theData.scheduled_start_date = moment(
                args.dataOrder.scheduled_start_date
              ).toDate();
            }
          }
          delete theData.material_status;
          return { ...theData, ...args.dataOperations };
        });
        loadingShow(true, 'Orders adjusting....');
        let theCodes = theDatas.map((theData: any) => {
          if (args.dataOrder.scheduled_start_date) {
            let theDifference = moment(
              args.dataOrder.scheduled_start_date
            ).diff(theData.scheduled_start_date, 'millisecond');
            theData.scheduled_end_date = moment(
              theData.scheduled_end_date?.toString()
            )
              .add(theDifference, 'millisecond')
              .toDate();

            args.dataOrder.scheduled_start_date =
              args.dataOrder?.scheduled_start_date?.toString();
          }
          return { ...theData, ...args.dataOrder, isEffected: true };
        });
        try {
          EditOperations(theEdittedOp);
        } catch (error) {
          Message.error('Error occured while updating operations');
        }

        if (ERP_TYPE === 'MEX') {
          const serverOffsetMillis = 60 * 1000 * -600;

          const localOffset = new Date().getTimezoneOffset();
          const localOffsetMillis = 60 * 1000 * localOffset;

          const differenceOffsetMillis = serverOffsetMillis - localOffsetMillis;

          theDatas.map((item: any) => {
            item.scheduled_start_date = new Date(
              new Date(item.scheduled_start_date)?.getTime() +
              differenceOffsetMillis
            ).toString();
            item.scheduled_end_date = new Date(
              new Date(item.scheduled_end_date)?.getTime() +
              differenceOffsetMillis
            ).toString();
          });
        }
        EditMassOrder(
          theCodes,
          () => {
            loadingShow(false);
            Message.success('Success');
            buildQuery(refreshTokens[Math.floor(Math.random() * (3 + 1))]);
          },
          -timezone_offset
        );
      }
    }
  };
  return (
    <div>
      {/* {reduxSearchS.isResetDataLoading ? (
        <>{gridCPWorkorder.showSpinner()}</>
      ) : null} */}
      {!noNeedFilterPanel ? (
        <GlobalSearch
          id={'cloud-planner-orders-filter'}
          height={ERP_TYPE == 'MEX' ? '530px' : '540px'}
          applyFilter={FilterPrio.bind(this)}
          clearFilter={clearFilter.bind(this)}
          Component1={PriorityMultiSelect.bind(this)}
          Component2={StatusMultiSelect.bind(this)}
          Component3={AssetInput.bind(this)}
          Component4={TypeInput.bind(this)}
          Component5={RespInput.bind(this)}
          Component6={ScheduleStartDateInput.bind(this)}
          Component7={ReferenceInput.bind(this)}
          Component8={WorkOrderCodeInput.bind(this)}
          Component9={DepartmentFilterInput.bind(this)}
          Component10={SectionFilterInput.bind(this)}
          Component11={PontoReferenceFilterInput.bind(this)}
          Component12={HoldReasonFilterInput.bind(this)}
          Component13={ScheduleNumberComponent.bind(this)}
        />
      ) : null}
      <GlobalGrid
        id='cloud-planner-workorders'
        columns={theColumns}
        height={'calc(-290px + 100vh)'}
        query={current_query}
        toolbarOptions={toolbarOptions}
        //get_query={'order'}
        get_query={gridGetQuery}
        edit_query={'order/edit'}
        delete_query={'order/delete'}
        signalOfLoad={loadSignal}
        refreshRequest={refreshRequest}
        contextMenuItems={contextMenuItems}
        contextMenuClick={contextMenuClick}
        gridRef={onCreated.bind(this)}
        allowMultiSelection={multiSelection}
        allowCheckBox
        additinalToolbarClick={toolbarClickExtends.bind(this)}
        queryCellInfo={queryCellInfo.bind(this)}
        additionalCrudParams={{ isEffected: 1 }}
        theEditOptions={editOptions}
        refreshRequestHandle={() => {
          setrefreshRequest('false');
        }}
      />
      {showTemplateDialog ? (
        <GlobalDialog
          // refDialog={(ref: DialogComponent) => (dialog = ref)}
          showDialog={showTemplateDialog}
          setShowDialog={(val: boolean) => setShowTemplateDialog(val)}
          header={`Templates`}
          width={'75%'}
          height={'55%'}
          hideDoneButton={false}
        >
          <OperationTemplate isWorkorderSide order_detail={order_detail} />
        </GlobalDialog>
      ) : null}
      <>
        {hideAddDialog ? (
          <GlobalDialog
            showDialog={hideAddDialog}
            setShowDialog={(val) => setHideAddDialog(val)}
            header='Order Attachments'
            width={'75%'}
            height={'55%'}
            hideDoneButton={false}
          >
            <OrderAttachments outter_order_code={currentWOC} />
          </GlobalDialog>
        ) : null}
      </>
      {massiveEditDialog ? (
        <MassiveOrderEdit
          callback={massCallBack}
          massiveEditDialog={massiveEditDialog}
          setMassiveEditDialog={(val: boolean) => setMassiveEditDialog(val)}
        />
      ) : null}

      {hideDialogEventPlan ? (
        <AssignWorkOrderDialog
          hideDialogEventPlan={hideDialogEventPlan}
          selectedOrders={gridCPWorkorder?.getSelectedRecords()}
          setHideDialogEventPlan={(val: boolean) => {
            setHideDialogEventPlan(val);
            refreshGridFunction();
          }}
          theModel={theDatas}
        />
      ) : null}

      {questionDialog ? (
        <GlobalDialog
          showDialog={questionDialog}
          setShowDialog={(val) => setQuestionDialog(val)}
          header='Fetch Records Message'
          width={'20%'}
          height={'15%'}
          hideDoneButton={true}
          content={'Which datas do you want to fetch?'}
          buttons={buttonsOrder}
        ></GlobalDialog>
      ) : null}

      {commitToErpClicked ? (
        <GlobalDialog
          showDialog={commitToErpClicked}
          setShowDialog={(val) => setcommitToErpClicked(val)}
          header='Commit to Erp'
          width={'20%'}
          height={'20%'}
          hideDoneButton={true}
          content={'Commit to Erp ?'}
          buttons={commitToErpButtonModel}
        ></GlobalDialog>
      ) : null}
      { }
    </div>
  );
};
export default React.memo(WorkOrders);
